<template>
  <div class="complete">
    <sn-breadcrumb :breadcrumb="[{
      title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_GHYY),
      replace: true,
      router: $sn.getConfig('pcEntranceArea') ? '/appointment/area' : '/appointment/depart'
    }, {
      title: '选择号源',
      replace: true,
      router: '/appointment/doctor'
    }, {
      title: '确认预约'
    }, {
      title: '预约成功'
    }]"></sn-breadcrumb>
    <div class="sn-f-col-c-c complete-region">
      <div class="iconfont icon-xuanzhong"></div>
      <div class="title">{{ appointmentContent }}成功</div>
      <div class="sub">就诊前请您先通过关注微信公众号或支付宝生活号绑定院内档案信息，祝您早日康复。</div>
      <div class="sn-f-c-c qr" v-if="qrCaption.length > 0">
        <div class="sn-f-col-c-c sn-pointer qr-single" :key="i" v-for="(title, i) in qrCaption">
          <div class="sn-f-c-c qr-direct">
            <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/qr/' + i + '-0-' + $sn.utils.getHospitalId() + '.png'">
          </div>
          <div class="qr-title" v-html="title"></div>
          <div class="qr-expand">
            <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/qr/' + i + '-1-' + $sn.utils.getHospitalId() + '.png'">
          </div>
        </div>
      </div>
      <div class="sn-f-c-c sn-pointer interaction" @click="appointment_mixin_navigateUrl('/appointment/record', '', {}, 'replace');">返回预约记录</div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import AppointmentMixin from '@/pages/appointment/appointment-mixin';

export default {
  mixins: [AppointmentMixin],
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      qrCaption: self.$sn.getConfig('qrCaption')
    };
  }
};
</script>
<style lang="scss" scoped>
.complete {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    width: 80%;
    border: 1px solid $border1;
    border-radius: 8px;
    padding: 40px 0;
    margin: 40px auto;

    .iconfont {
      font-size: 80px;
      color: $main;
    }

    .title {
      @include fs(24);

      font-weight: bold;
      color: $main;
      margin-top: 10px;
    }

    .sub {
      @include fs(18);

      color: $text3;
      margin-top: 10px;
    }

    .qr {
      margin-top: 30px;

      .qr-single {
        margin-right: 40px;
        position: relative;

        &:last-child {
          margin-right: 0;
        }

        &:hover {
          .qr-expand {
            display: block;
          }
        }

        .qr-direct {
          overflow: hidden;
          width: 100px;
          height: 100px;
          margin: 5px 0;

          img {
            width: 100px;
            height: auto;
          }
        }

        .qr-title {
          @include fs(16);

          overflow: hidden;
          width: 100%;
          height: 40px;
          color: $text3;
          text-align: center;
        }

        .qr-expand {
          display: none;
          overflow: hidden;
          width: 300px;
          background-color: $main11;
          border-radius: 10px;
          padding: 10px;
          position: absolute;
          top: 115px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 999;

          img {
            width: 280px;
            height: auto;
          }
        }
      }
    }

    .interaction {
      @include fs(14);

      overflow: hidden;
      width: 200px;
      height: 40px;
      background-color: $main;
      color: $white;
      border-radius: 5px;
      margin-top: 30px;
    }
  }
}
</style>
